import React from 'react';
import { Container, Paper, Typography, Box, Link } from '@mui/material';

const Imprint = () => {
    return (
        <Container maxWidth="md">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography variant="h4" gutterBottom>
                    Impressum
                </Typography>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="h6">Anbieterkennzeichnung</Typography>
                    <Typography component="p">
                        <strong>Ruhr-Universität Bochum</strong><br />
                        Universitätsstraße 150<br />
                        44801 Bochum<br />
                        Deutschland
                    </Typography>
                    <Typography component="p">
                        Telefon: +49 234 32-201<br />
                        Web: <Link href="https://www.ruhr-uni-bochum.de" target="_blank" rel="noopener">www.ruhr-uni-bochum.de</Link>
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 2 }}>Rechtsform und Vertretung</Typography>
                    <Typography component="p">
                        Die Ruhr-Universität Bochum ist eine Körperschaft des öffentlichen Rechts.
                        Sie wird durch das Rektorat gesetzlich vertreten.
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 2 }}>Zuständige Aufsichtsbehörde</Typography>
                    <Typography component="p">
                        Ministerium für Kultur und Wissenschaft des Landes Nordrhein-Westfalen<br />
                        Völklinger Straße 49<br />
                        40221 Düsseldorf
                    </Typography>

                    <Typography variant="h6" sx={{ mt: 2 }}>Umsatzsteuer-Identifikationsnummer</Typography>
                    <Typography component="p">
                        DE 127 056 261
                    </Typography>

                    <Typography variant="body2" color="textSecondary" sx={{ mt: 4 }}>
                        Dies ist ein Forschungsprojekt-Demonstrator. Inhalte dienen ausschließlich Entwicklungszwecken.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default Imprint;